import { render, staticRenderFns } from "./Kretouches.vue?vue&type=template&id=d452facc"
import script from "./Kretouches.vue?vue&type=script&lang=js"
export * from "./Kretouches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports